import styled from 'styled-components'
import { DARK_VIOLET, GRAYSCALE_HOVER, NEUTRAL_100, PALE_BLUE, PRIMARY, WHITE } from '../../styles/colors'
import { INTER } from '../../styles/fonts'

export const Container = styled.div`
  position: relative;
  width: 100%;
` as any

export const DropdownButton = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 16px;
  background-color: ${PALE_BLUE};
  border-radius: 12px;
  border: 1px solid ${NEUTRAL_100};
  cursor: pointer;
` as any

export const DropdownText = styled.span`
  font-family: ${INTER.medium};
  font-size: 14px;
  color: ${DARK_VIOLET};
` as any

export const DropdownMenu = styled.div`
  position: absolute;
  top: calc(100% + 8px);
  left: 0;
  right: 0;
  background-color: ${WHITE};
  border-radius: 12px;
  border: 1px solid ${NEUTRAL_100};
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  overflow: hidden;
` as any

interface OptionItemProps {
  $isLast: boolean
}

export const OptionItem = styled.div<OptionItemProps>`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 16px;
  border-bottom: ${props => props.$isLast ? 'none' : `1px solid ${NEUTRAL_100}`};
  cursor: pointer;
  background-color: ${WHITE};

  &:hover {
    background-color: ${GRAYSCALE_HOVER};
  }
` as any

export const OptionText = styled.span`
  font-family: ${INTER.regular};
  font-size: 13px;
  color: ${DARK_VIOLET};
` as any

export const CheckIcon = styled.svg`
  width: 20px;
  height: 20px;
  fill: none;

  path {
    stroke: ${PRIMARY};
    stroke-width: 2;
    stroke-linecap: round;
    stroke-linejoin: round;
  }
` as any
